var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0Default(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloudy_2 "
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_231)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "url(#paint0_linear_2_231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 4",
    opacity: 0.9,
    d: "M25.6624 26.8693H36.15C39.3809 26.8693 42 24.2362 42 20.9882C42 17.7401 39.3809 15.107 36.15 15.107C35.175 15.107 34.2558 15.3468 33.4474 15.7709C32.3217 12.4886 29.2223 10.1307 25.575 10.1307C20.9772 10.1307 17.25 13.8777 17.25 18.5C17.25 18.5947 17.2516 18.6891 17.2547 18.7831C15.9125 19.508 15 20.9326 15 22.5716C15 24.9451 16.914 26.8693 19.275 26.8693H25.575C25.5881 26.8693 25.6624 26.8693 25.6624 26.8693H25.575H25.6624Z",
    fill: "url(#paint1_linear_2_231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0994 49.616C6.23151 41.8586 -11.5738 65.3681 -11.5738 65.3681L0.233002 84H84L84.3154 67.4805C84.3154 67.4805 81.1942 67.0293 79.9726 66.7123C61.4808 61.9138 40.191 57.4762 23.0994 49.616Z",
    fill: "url(#paint2_linear_2_231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 55_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6457 60.616C91.3217 60.2617 100.96 75.919 100.96 75.919V104.97H-17L-16.4425 77.3204C-16.4425 77.3204 11.4538 79.7944 20.9876 77.3204C39.4795 72.5219 48.5919 60.7718 61.6457 60.616Z",
    fill: "url(#paint3_linear_2_231)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    opacity: 0.9,
    cx: 57.5,
    cy: 54.5,
    rx: 4.5,
    ry: 9.5,
    fill: "#7AB8FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M57.5 60.6081V69.0232",
    stroke: "#406689"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    opacity: 0.9,
    cx: 20.5,
    cy: 52.6667,
    rx: 3.5,
    ry: 6.5,
    fill: "#8FB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M20.5 56.5923V62.4829",
    stroke: "#80A1BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 4_2",
    opacity: 0.9,
    d: "M73.4986 38.2179H65.9151C63.5789 38.2179 61.6851 36.3302 61.6851 34.0016C61.6851 31.6731 63.5789 29.7854 65.9151 29.7854C66.6201 29.7854 67.2848 29.9573 67.8694 30.2614C68.6833 27.9083 70.9245 26.2179 73.5618 26.2179C76.8864 26.2179 79.5815 28.9042 79.5815 32.2179C79.5815 32.2858 79.5804 32.3534 79.5782 32.4208C80.5486 32.9405 81.2085 33.9618 81.2085 35.1368C81.2085 36.8384 79.8245 38.2179 78.1173 38.2179H73.5618C73.5523 38.2179 73.4986 38.2179 73.4986 38.2179H73.5618H73.4986Z",
    fill: "url(#paint4_linear_2_231)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_231",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#A8D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_231",
    x1: 42,
    y1: 10.1307,
    x2: 42,
    y2: 26.8693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_231",
    x1: 84.3154,
    y1: 47.6913,
    x2: 84.3154,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_231",
    x1: -17,
    y1: 60.6081,
    x2: -17,
    y2: 104.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_231",
    x1: 61.6851,
    y1: 26.2179,
    x2: 61.6851,
    y2: 38.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Default);
export default __webpack_public_path__ + "static/media/0_Default.0588bc89106fa3e92687c69ba3103dc0.svg";
export { ForwardRef as ReactComponent };